import React from 'react';
import './services.css';

const services = [
  {
    number: '01',
    title: 'Website Design & Development',
    description:
      'Modern, responsive websites built around your brand, business goals and customers.',
    icon: 'bx bx-layout',
  },
  {
    number: '02',
    title: 'Website Redesign',
    description:
      'A complete visual and technical upgrade for websites that feel outdated or underperform.',
    icon: 'bx bx-refresh',
  },
  {
    number: '03',
    title: 'Custom Web Applications',
    description:
      'Reliable digital tools, portals and tailored web solutions that simplify everyday work.',
    icon: 'bx bx-code-alt',
  },
  {
    number: '04',
    title: 'E-commerce Solutions',
    description:
      'Clear, secure online stores designed to make products easy to discover and purchase.',
    icon: 'bx bx-shopping-bag',
  },
  {
    number: '05',
    title: 'Performance & SEO',
    description:
      'Faster loading, strong technical foundations and better visibility in search results.',
    icon: 'bx bx-line-chart',
  },
  {
    number: '06',
    title: 'Support & Maintenance',
    description:
      'Ongoing updates, monitoring and dependable support after your solution goes live.',
    icon: 'bx bx-shield-quarter',
  },
];

const Services = () => {
  return (
    <section className="services-container" id="services">
      <div className="services-inner">
        <header className="services-heading">
          <div>
            <span className="services-eyebrow">WHAT WE DO</span>
            <h2>Digital expertise for every stage of your growth.</h2>
          </div>
          <p>
            From the first idea to launch and long-term support, we create
            practical digital solutions that help businesses work smarter and
            grow with confidence.
          </p>
        </header>

        <div className="services-grid">
          {services.map((service) => (
            <article className="service-card" key={service.number}>
              <div className="service-card-top">
                <span className="service-number">{service.number}</span>
                <i className={service.icon} aria-hidden="true" />
              </div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              <a href="#contact" aria-label={`Discuss ${service.title}`}>
                Discuss your project <i className="bx bx-right-arrow-alt" aria-hidden="true" />
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
